import { Controller } from '@hotwired/stimulus'
import type { App } from 'vue'

import { createApp } from '@app/adapters/create-app'
import AutomaticallyFollowedBanner from '@app/application/workflows/components/automatically-followed-banner.vue'

// Mounts the automatically-followed banner Vue component on connect and unmounts
// it on disconnect, keyed off the element's presence via Stimulus' MutationObserver.
export default class extends Controller {
  static values = { supportArticleUrl: String }

  declare supportArticleUrlValue: string
  private app?: App

  connect(): void {
    // Guard against a re-connect without an intervening disconnect leaking the
    // previous app (mirrors the destroy-before-mount in the checks controller).
    this.app?.unmount()
    this.app = createApp(AutomaticallyFollowedBanner, {
      supportArticleUrl: this.supportArticleUrlValue,
    })
    this.app.mount(this.element)
  }

  disconnect(): void {
    this.app?.unmount()
    this.app = undefined
  }
}
